import React, { useContext, useState } from 'react'
import css from "./signIn.module.scss"
import { toAbsoluteUrl } from "../../utils/assetHelper.js"
import { Input } from "../../componentsV1/Input"
import { AuthContext } from "../../context/auth.js"
import { loginApi, currentUserApi, getCustomerGroupApi, updateCartApi } from "../../api/index.js"
import { setLocalStorage } from '../../helpers/localStorage.js'
import { useNavigate } from 'react-router-dom'
import Logo from "../../assets/v1/logo.png"

export const SignIn = () => {
  const navigate = useNavigate()
  const { setSignInModal, setSignUpModal, setRestoreModal, login, setIsLoading, setNotification } = useContext(AuthContext)
  const [Email, setEmail] = useState('')
  const [Password, setPassword] = useState('')
  const [error, setError] = useState('')


  const Login = () => {
    setIsLoading(true)
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(Email)) {
      loginApi({ email: Email, password: Password }).then((res) => {
        if (res?.data?.access_token) {
          setLocalStorage('identifyntoken', res?.data?.access_token)
          currentUserApi().then((user) => {
            let data = user.data
            getCustomerGroupApi(data?.customer?.id).then((customerGroup) => {
              data.customer.groups = customerGroup.data?.customerGroups[0]?.groups[0]?.name
            })
            login(data)
            setIsLoading(false)
            setError('')
            setEmail('')
            setPassword('')
            setSignInModal(false)
            setNotification({
              message: 'Logged in successfully',
              type: 'green',
            })
          })
          navigate('/v1')
        } else {
          setError("Invalid Email or Password")
          setIsLoading(false)
        }
      }).catch((err) => {
        setError("Invalid Email or Password")
        setIsLoading(false)
      })
    } else {
      setError('Please enter a valid Email Address')
      setIsLoading(false)
    }
  }

  return (
    <div className={css.modalWrapper}>
      <div className={css.signInModalContent}>
        <i className={`fal fa-times ${css.closeIcon}`} onClick={() => {
          setSignInModal(false)
        }}></i>
        <div className={css.leftContainer}>
          <span className={css.icon}>
            <i class="fal fa-sign-in"></i>
          </span>
          <div>
            <h1>Welcome Back to IDENTiFYN®</h1>
            <p>Please sign-in.</p>
          </div>
          <div>
            <Input type='email' className={"Email"} style={{ marginBottom: '20px' }} required label={'Email'} value={Email} onChange={(e) => setEmail(e.target.value)} />
            <Input type='password' className={"Password"} required label={'Password'} value={Password} onChange={(e) => setPassword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && Login()} />
            <button className={css.forgotPassword}
              onClick={() => {
                setRestoreModal(true)
              }}
            >Forgot Password?</button>
          </div>
          <button className={`btn ${css.signInBtn}`} type="btn"
            disabled={!Email || !Password}
            onClick={() => {
              Login()
            }}>Sign In</button>
          {error && <h4 style={{ color: '#DC1E00', textAlign: 'center', fontWeight: 500 }}>{error}</h4>}
          <p className={css.centerText}>Don’t have an Account? <button className={css.link} onClick={() => {
            setSignInModal(false)
            setSignUpModal(true)
          }}>Sign Up</button></p>
        </div>
        <div className={css.rightContainer}>
          <img src={Logo} alt="logo" />
        </div>
      </div>
    </div>
  )
}